module.exports = __webpack_public_path__ + "static/img/samajuri (2).8c6fea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (2).jpg
// module id = 9ROa
// module chunks = 0